$(function () {
  $('.mobile-menu-toggle, .mobile-menu-close').on('click', function (event) {
    if (!window.location.href.includes('mice')) {
      toggleMenu(event)
    }
  })

  $('.mobile-menu .has-children .first-level').on('click', function (event) {
    event.preventDefault()
    $(this).closest('.has-children').toggleClass('opened')
  })

  // Mobile menutoggle
  function toggleMenu(event) {
    event.preventDefault()
    $('html').toggleClass('opened-left')
  }
})
